import { type FC } from 'react'

import { ProductSearchPagination } from '../../../product-search'
import { CmsAlgoliaHits } from '../CmsAlgoliaHits'

export const StoryblokAlgoliaCategorySearchResults: FC = () => (
  <div className="desktop:col-span-7">
    <CmsAlgoliaHits />
    <ProductSearchPagination />
  </div>
)
